import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { getQiniuSignedUrl } from './qiniuMedia.js';
import { v4 as uuidv4 } from 'uuid';
import { LOCAL_ASSET } from './localAssets.js';

export const QUICK_NAV_BLOCK_TYPE = 'quick-nav-grid';

const DEFAULT_QUICK_NAV_ITEM_PRESETS = [
	{ text: '装饰画' },
	{ text: '收纳盒' },
	{ text: '香氛' },
	{ text: '花盆' },
	{ text: '花瓶' },
	{ text: '时钟' },
	{ text: '镜子' },
	{ text: '饰品' },
	{ text: '人造花' },
];

const DEFAULT_QUICK_NAV_TEXT_COLOR = '#666666';

function createLocalAssetFallback(index) {
	return LOCAL_ASSET.quickNavGridItems?.[index % (LOCAL_ASSET.quickNavGridItems?.length || 1)]
		|| LOCAL_ASSET.qrcodeNavDefault;
}

export function createDefaultQuickNavItem(preset = {}, index = 0) {
	const presetData = DEFAULT_QUICK_NAV_ITEM_PRESETS[index] || {};
	return {
		id: uuidv4(),
		text: preset.text ?? presetData.text ?? '功能入口',
		image: {
			id: `quick-nav-item-${uuidv4()}`,
			filename: 'demo.png',
			previewUrl: createLocalAssetFallback(index),
			url: '',
			local: false,
		},
		textColor: normalizeHexColor(preset.textColor ?? DEFAULT_QUICK_NAV_TEXT_COLOR),
		jumpLink: preset.jumpLink?.type ? { ...preset.jumpLink } : null,
	};
}

export function createDefaultQuickNavItems(count = 9) {
	const items = [];
	for (let i = 0; i < count; i += 1) {
		items.push(createDefaultQuickNavItem({}, i));
	}
	return items;
}

export function isQuickNavGridBlock(blockType) {
	return blockType === QUICK_NAV_BLOCK_TYPE;
}

export function getQuickNavGridDefaults() {
	return {
		items: createDefaultQuickNavItems(9),
	};
}

export function normalizeQuickNavItem(item = {}, index = 0) {
	const fallback = createDefaultQuickNavItem({}, index);
	return {
		id: item.id || fallback.id,
		text: item.text?.trim?.() || fallback.text,
		image: normalizeQuickNavImage(item.image, fallback.image),
		textColor: normalizeHexColor(item.textColor || fallback.textColor),
		jumpLink: item.jumpLink?.type ? { ...item.jumpLink } : null,
	};
}

export function normalizeQuickNavItems(items = []) {
	if (!items.length) {
		return createDefaultQuickNavItems(9);
	}
	return items.map((item, index) => normalizeQuickNavItem(item, index));
}

export function normalizeQuickNavGridData(data = {}) {
	return {
		items: normalizeQuickNavItems(data.items),
	};
}

export function getQuickNavImageUrl(image) {
	if (!image) return '';
	return getQiniuSignedUrl(image.previewUrl || image.url || '');
}

export function replaceQuickNavImage(currentImage, file, createLocalImageItem) {
	if (currentImage?.local) {
		revokeLocalImageUrl(currentImage.previewUrl);
	}
	return createLocalImageItem(file);
}

function normalizeQuickNavImage(image, fallback) {
	if (!image?.previewUrl && !image?.url) {
		return fallback ? { ...fallback } : null;
	}
	return normalizeStoredImageItem(image, fallback || { id: 'quick-nav-image' });
}
